// extracted by mini-css-extract-plugin
export var errorIcon = "_mz-1";
export var nameLogo = "_mz-0";